const useGrid = () => {
  const props = {
    columns: {
      type: [String, Number],
      required: false,
      default: 0,
      validator: (value: string|number) => Number.parseInt(`${ value }`) >= 0
    }
  }

  return {
    props
  }
}

export default useGrid
